<template>
  <div>
    <b-row>
      <b-col>
        <p>{{ travelMessage }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <b-button variant="primary" @click="requestTravel(true, true)">Yes</b-button>
          <b-button variant="secondary" @click="requestTravel(true, false)">Not right now</b-button>
          <b-button variant="warning" @click="requestTravel(false)">No</b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Prop, Component, Vue } from 'vue-property-decorator';
import { RegistrationRequest } from '@/model/registration';
import _ from 'underscore';
import { errorModalOptions } from '@/util/formatters';

@Component({})
export default class RequestTravel extends Vue {
  @Prop({ type: RegistrationRequest, default: null }) registrationRequest;
  @Prop({ type: [String, Object] }) requestType;
  @Prop({ type: Boolean, default: false }) fromTravel;

  get activeUser() {
    return this.$store.getters['userSession/getUser'];
  }

  get travelMessage() {
    if (_(this.registrationRequest).isEmpty()) {
      return 'Yikes, something went wrong!';
    }

    const user = this.registrationRequest.user;
    const session = this.registrationRequest.session;
    return `Would you like to request travel for ${user.fullname}, ${session.label}?`;
  }

  async requestTravel(travelNeeded, doItNow = false) {
    //Update registration and submit
    this.registrationRequest.registration.declinedTravel = !travelNeeded;

    try {
      await this.$store.dispatch(
        'registration/declinedTravel',
        {
          registrationId: this.registrationRequest.registration.id,
          declinedTravel: this.registrationRequest.registration.declinedTravel
        },
        { root: true }
      );
    } catch (error) {
      await this.$bvModal.msgBoxOk(error.message, errorModalOptions);
      return;
    }

    if (travelNeeded && doItNow) { //} && !this.fromTravel) {
      return this.$router.push({
        name: 'myTravel',
        query: { 'registration-id': this.registrationRequest.registration.id }
      });
    }

    //Notify parent
    this.$emit('done', {
      travelNeeded,
      doItNow,
      attendeeId: this.registrationRequest.user.attendeeId,
      registrationId: this.registrationRequest.registration.id
    });
  }
}
</script>

<style scoped></style>
